import { Link } from 'react-router-dom'
import { formatDateMoment, innerHTML, setNumberWithPoint } from 'utils/utils'
import icImageDefault from 'assets/images/ic-image-x.svg'

export const TABLE_VOUCHER = {
    name: 'Voucher',
    column: [
        {
            name: 'Kode Voucher',
            key: 'code',
            render: ({ item }) => (
                <Link
                    to={`/voucher/voucher-list/update-voucher?voucherId=${item?.id}`}
                    className={'flex flex-row gap-3 items-center'}
                >
                    <img className={'w-7 h-7'} src={item?.thumbnail || icImageDefault} alt={item?.code} />
                    <div className={'flex space-x-2'}>
                        <div className={'uppercase font-medium text-blue-90 hover:font-bold hover:underline'}>
                            {item?.code}
                        </div>
                        {item?.status === 'draft' && (
                            <>
                                <div>-</div>
                                <div className={'capitalize'}>{item?.status}</div>
                            </>
                        )}
                    </div>
                </Link>
            ),
        },
        {
            name: 'Tipe',
            key: 'type',
            className: 'capitalize',
        },
        {
            name: 'Nilai',
            key: 'amount',
            render: ({ value }) => <div>{value ? setNumberWithPoint(value) : '-'}</div>,
        },
        {
            name: 'Deskripsi',
            key: 'description',
            render: ({ value }) => <div dangerouslySetInnerHTML={innerHTML(value)} />,
        },
        {
            name: 'Usage / Limit',
            key: 'usage',
            className: 'text-center',
            render: ({ item }) => (
                <div>
                    {item?.usage_count || 0} / {item?.usage_limit || 0}
                </div>
            ),
        },
        {
            name: 'Expired Date',
            key: 'date_expires',
            classNameHeader: '!text-center',
            className: 'text-center',
            render: ({ value }) => <div>{value ? formatDateMoment(value, 'DD/MM/YYYY HH:mm') : '-'}</div>,
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    search: '',
    page: 1,
    limit: 20,
    order_by: 'created_at',
    order_type: 'desc',
}

export const SORT_VOUCHER = [
    {
        label: 'Sort By Created At Desc',
        key: 'created_at-desc',
        name: 'sort-product',
    },
    {
        label: 'Sort By Created At Asc',
        key: 'created_at-asc',
        name: 'sort-product',
    },
    {
        label: 'Sort By Expired Date Desc',
        key: 'expired_at-desc',
        name: 'sort-product',
    },
    {
        label: 'Sort By Expired Date Asc',
        key: 'expired_at-asc',
        name: 'sort-product',
    },
]

export const FILTER_VOUCHER = [
    {
        title: 'Tipe Voucher',
        key: 'type',
        list: [
            {
                name: 'Fixed Cart Discount',
                value: 'fixed-cart-discount',
            },
            {
                name: 'Fixed Product Discount',
                value: 'fixed-product-discount',
            },
            {
                name: 'Shipping Discount',
                value: 'shipping-discount',
            },
            {
                name: 'Free Gift',
                value: 'free-gift',
            },
        ],
    },
]
